import React, {
    Component,
    PropTypes
} from 'react';
import {
    render,
    ReactDOM
} from 'react-dom';

import App from './modules/App';
import Home from './modules/home/Home';
import Login from './modules/login';
import OTAAdd from './modules/ota/addOTA'
import OTAIndex from './modules/ota/otaIndex'
import SearchBindDevice from './modules/bump/back/dvcBase/searchBindDevice'
import SearchBindDeviceId from './modules/bump/back/dvcBase/searchBindDevice'
{ /*bump*/
}
{ /*基础配置*/
}
import Config from './modules/bump/config/configIndex';
import PframeworkIndex from "./modules/bump/config/pframework/pframeworkIndex";
import PframeworkCreate from "./modules/bump/config/pframework/pframeworkCreate";
import PframeworkEdit from "./modules/bump/config/pframework/pframeworkEdit";

import DvctypeIndex from "./modules/bump/config/dvctype/dvctypeIndex";
import DvctypeCreate from "./modules/bump/config/dvctype/dvctypeCreate";
import DvctypeEdit from "./modules/bump/config/dvctype/dvctypeEdit";

import PanalyzeIndex from "./modules/bump/config/panalyze/panalyzeIndex";
import PanalyzeEdit from "./modules/bump/config/panalyze/panalyzeEdit";
import PanalyzeCreate from "./modules/bump/config/panalyze/panalyzeCreate";

import PparamIndex from "./modules/bump/config/pparam/pparamIndex";
import PparamEdit from "./modules/bump/config/pparam/pparamEdit";
import PparamCreate from "./modules/bump/config/pparam/pparamCreate";

import MetaIndex from './modules/bump/config/meta/metaIndex';

{ /*bump*/
}
{ /*车辆管理*/
}
import Back from './modules/bump/back/backIndex.js';

import AirPurifierSearch from './modules/bump/back/dvcBase/airPurifierSearch'
{ /*mica*/
}

import DvcStateIndex from './modules/bump/back/dvcBase/dvcStateIndex';
import UserTypeIndex from './modules/ella/user/userType/userTypeIndex'

import UserTypeEdit from './modules/ella/user/userType/userTypeEdit'
import UserTypeAdd from './modules/ella/user/userType/userTypeAdd'

import ExtendsValue from './modules/ella/user/userType/extendsValue'

import ExtendsValueAdd from './modules/ella/user/userType/extendsValueAdd'


import SubsystemsyncIndex from './modules/ella/user/subsystemsync/subsystemsyncIndex'
import SubsystemsyncEdit from './modules/ella/user/subsystemsync/subsystemsyncEdit'
import SubsystemsyncAdd from './modules/ella/user/subsystemsync/subsystemsyncAdd'
import SubsystemsyncDetail from './modules/ella/user/subsystemsync/subsystemsyncDetail'

import EmailIndex from './modules/ella/user/email/emailIndex'

import MsgIndex from './modules/ella/user/msg/msgIndex'
import OrgStructure from './modules/ella/orgStructure/orgStructure'

import UserList from './modules/ella/user/user/userList'
import UserEdit from './modules/ella/user/user/userEdit'
import UserAdd from './modules/ella/user/user/userAdd'
import UserDetail from './modules/ella/user/user/userDetail'

import NormalUser from './modules/ella/user/user/normalUser'
import NormalUserAdd from './modules/ella/user/user/normalUserAdd'
import NormalUserEdit from './modules/ella/user/user/normalUserEdit'
import NormalUserDetail from './modules/ella/user/user/normalUserDetail'
import NormalUserHandle from './modules/ella/user/user/normalUserHandle'


import AdministratorsList from'./modules/ella/user/user/administratorsList'
import AdministratorsAdd from'./modules/ella/user/user/administratorsAdd'
import AdministratorsDetail from'./modules/ella/user/user/administratorsDetail'
import AdministratorsEdit from'./modules/ella/user/user/administratorsEdit'


import BusinessList from'./modules/ella/user/user/businessList'
import BusinessAdd from'./modules/ella/user/user/businessAdd'
import BusinessDetail from'./modules/ella/user/user/businessDetail'
import BusinessEdit from'./modules/ella/user/user/businessEdit'

import AreaPermission from './modules/ella/user/user/areaPermission'


import RoleIndex from './modules/ella/role/roleIndex'
import RoleEdit from './modules/ella/role/roleEdit'
import RoleDetail from './modules/ella/role/roleDetail'
import RoleAdd from './modules/ella/role/roleAdd'

{ /*ella*/}
{ /*权限管理*/}
import PagerIndex from './modules/ella/permission/pager/pageper'
import SubsystemIndex from './modules/ella/permission/subsystem/subsystem'
import SubsystemCreate from './modules/ella/permission/subsystem/subsystemCreate'
import SubsystemEdit from './modules/ella/permission/subsystem/subsystemEdit'
import SubsystemDetail from './modules/ella/permission/subsystem/subsystemDetail'
{ /*ella*/
}
{ /*APP管理*/
}
import APPIndex from './modules/ella/app/appIndex'
import APPCreate from './modules/ella/app/appCreate'
import APPEdit from './modules/ella/app/appEdit'

import UserDistributionStatistics from './modules/ella/statistics/userDistributionStatistics'
import UserInformationStatistics from './modules/ella/statistics/userInformationStatistics'

import {
    Router,
    Route,
    hashHistory,
    IndexRoute,
    browserHistory
} from 'react-router'
const chooseLocale = (lang) => {
    switch (lang) {
        case 'en':
            return en_US;
            break;
        case 'zh':
            return zh_cn;
            break;
        default:
            return en_US;
            break;
    }
};
const requireAuth = (nextState, replace) => {
    if (window.sessionStorage.getItem('auth') != 'ok') {
        // Redirect to Login page if not an vip
        replace({pathname: '/login'})
    }
}

const deleteAuth = (nextState) => {
    sessionStorage.setItem('token','');
}

const deleteState = () => {
    sessionStorage.removeItem('state');
}


const root = (
    <Router history={hashHistory}>
        <Route path='/login' component={Login} onLeave={deleteState}/>
        <Route path="/" component={App} onEnter={requireAuth} onLeave={deleteAuth}>
            <IndexRoute component={Home}/>
            <Route path="/config" component={Config}>
                <Route path="/config/pframework/pframeworkIndex" component={PframeworkIndex}/>
                <Route path="/config/pframework/pframeworkCreate"
                       component={PframeworkCreate}/>
                <Route path="/config/pframework/pframeworkEdit/:id"
                       component={PframeworkEdit}/>

                <Route path="/config/dvctype/dvctypeIndex" component={DvctypeIndex}/>
                <Route path='/config/dvctype/dvctypeCreate' component={DvctypeCreate}/>
                <Route path='/config/dvctype/dvctypeEdit/:id' component={DvctypeEdit}/>

                <Route path="/config/panalyze/panalyzeIndex" component={PanalyzeIndex}/>
                <Route path="/config/panalyze/panalyzeCreate" component={PanalyzeCreate}/>
                <Route path='/config/panalyze/panalyzeEdit/:id' component={PanalyzeEdit}/>

                <Route path="/config/pparam/pparamIndex" component={PparamIndex}/>
                <Route path="/config/pparam/pparamCreate" component={PparamCreate}/>
                <Route path="/config/pparam/pparamEdit/:id" component={PparamEdit}/>
                <Route path="/config/meta/metaIndex" component={MetaIndex}/>

                <Route path='/back/dvcBase/dvcStateIndex' component={DvcStateIndex}/>
                <Route path='/back/dvcBase/airPurifierSearch' component={AirPurifierSearch}/>
                <Route path='/back/dvcBase/searchBindDevice' component={SearchBindDevice}/>
                <Route path='/back/dvcBase/searchBindDevice/:id' component={SearchBindDeviceId}/>


            </Route>
            {/*ella*/}
            <Route path="/ella/user/userType/userTypeIndex" component={UserTypeIndex}/>
            <Route path="/ella/user/userType/userTypeEdit/:id" component={UserTypeEdit}/>
            <Route path="/ella/user/userType/userTypeAdd" component={UserTypeAdd}/>

            <Route path="/ella/user/userType/extendsValue/:userTypeId" component={ExtendsValue}/>
            <Route path="/ella/user/userType/extendsValueAdd/:userTypeId" component={ExtendsValueAdd}/>

            <Route path="/ella/role/roleIndex" component={RoleIndex}/>
            <Route path="/ella/role/roleEdit/:id" component={RoleEdit}/>
            <Route path="/ella/role/roleDetail/:id" component={RoleDetail}/>
            <Route path="/ella/role/roleAdd" component={RoleAdd}/>

            <Route path="/ella/user/subsystemsync/subsystemsyncIndex" component={SubsystemsyncIndex}/>
            <Route path="/ella/user/subsystemsync/subsystemsyncEdit/:id" component={SubsystemsyncEdit}/>
            <Route path="/ella/user/subsystemsync/subsystemsyncDetail/:id"
                   component={SubsystemsyncDetail}/>
            <Route path="/ella/user/subsystemsync/subsystemsyncAdd" component={SubsystemsyncAdd}/>

            <Route path="/ella/user/email/emailIndex" component={EmailIndex}/>
            <Route path="/ella/user/msg/msgIndex" component={MsgIndex}/>
            <Route path="/ella/orgStructure/orgStructure" component={OrgStructure}/>

            <Route path="/ella/user/user/userList" component={UserList}/>
            <Route path="/ella/user/user/userEdit/:id" component={UserEdit}/>
            <Route path="/ella/user/user/userDetail/:id" component={UserDetail}/>
            <Route path="/ella/user/user/userAdd" component={UserAdd}/>

            <Route path="/ella/user/user/normalUser" component={NormalUser}/>
            <Route path='/ella/user/user/normalAdd' component={NormalUserAdd}/>
            <Route path='/ella/user/user/normalEdit/:id' component={NormalUserEdit}/>
            <Route path="/ella/user/user/normalUserDetail/:id" component={NormalUserDetail}/>
            <Route path="/ella/user/user/normalUserHandle/:id" component={NormalUserHandle}/>

            <Route path="/ella/user/user/administratorsList" component={AdministratorsList}/>
            <Route path="/ella/user/user/administratorsAdd" component={AdministratorsAdd}/>
            <Route path="/ella/user/user/administratorsEdit/:id" component={AdministratorsEdit}/>
            <Route path="/ella/user/user/administratorsDetail/:id" component={AdministratorsDetail}/>

            <Route path="/ella/user/user/businessList" component={BusinessList}/>
            <Route path="/ella/user/user/businessAdd" component={BusinessAdd}/>
            <Route path="/ella/user/user/businessEdit/:id" component={BusinessEdit}/>
            <Route path="/ella/user/user/businessDetail/:id" component={BusinessDetail}/>

            <Route path="/ella/user/user/areaPermission/:id" component={AreaPermission}/>

            <Route path="/ella/permission/pagerIndex" component={PagerIndex}/>
            <Route path="/ella/permission/subsystemIndex" component={SubsystemIndex}/>
            <Route path="/ella/permission/subsystemDetail/:id" component={SubsystemDetail}/>
            <Route path="/ella/permission/subsystemCreate" component={SubsystemCreate}/>
            <Route path="/ella/permission/subsystemEdit/:id" component={SubsystemEdit}/>
            <Route path="/ella/app" component={APPIndex}/>
            <Route path="/ella/appEdit/:id" component={APPEdit}/>
            <Route path="/ella/appCreate" component={APPCreate}/>

            <Route path='/ella/statistics/userDistributionStatistics' component={UserDistributionStatistics}/>
            <Route path='/ella/statistics/userInformationStatistics' component={UserInformationStatistics}/>

            <Route path='/ota/otaAdd' component={OTAAdd}/>
            <Route path='/ota/otaIndex' component={OTAIndex}/>
        </Route>
    </Router>
);
render(
    root,
    document.getElementById('app')
)


// WEBPACK FOOTER //
// ./index.js